( function ( _s ) {
	const getOuterHeight = el => {
		let height = el.offsetHeight;
		const style = getComputedStyle( el );

		height += parseInt( style.marginTop ) + parseInt( style.marginBottom );
		return height;
	};

	const setHeightOfSlideTrack = ( _track, _slides ) => {
		let height = 0;

		//first lets reset the heigh of the parent
		_track.css( 'height', '' );

		//let's get all the visible ones and get the tallest
		_slides.each( e => {
			if ( getOuterHeight( e ) > height ) {
				height = getOuterHeight( e );
			}
		} );

		//set the height of the track to the tallest
		_track.css( 'height', height + 'px' );
	};

	const doResize = ( _track, _slides ) => {
		setHeightOfSlideTrack(
			_track,
			_s(
				_slides.el.filter( i => {
					return i.classList.contains( 'is-visible' );
				} )
			)
		);
	};

	_s.fn.frSplideResizeHeightOfSlider = function ( splideInstance ) {
		const _root = _s( splideInstance.root );
		const _track = _root.find( ':scope > .splide__track' );
		const _slides = _track.find(
			':scope > .splide__list > .splide__slide:not(.splide__slide--clone)'
		);

		splideInstance.on( 'resized', () => {
			doResize( _track, _slides );
		} );

		//on page load
		doResize( _track, _slides );

		splideInstance.on( 'move', newIndex => {
			//all slides that aren't clones
			const slides = splideInstance.Components.Slides.get( true );

			slides.forEach( el => {
				if ( el.index === newIndex ) {
					setHeightOfSlideTrack( _track, _s( el.slide ) );
				}
			} );
		} );
	};
} )( window._s );
